import { render } from "./AudienceHeader.vue?vue&type=template&id=ce7003ce&scoped=true"
import script from "./AudienceHeader.vue?vue&type=script&lang=js"
export * from "./AudienceHeader.vue?vue&type=script&lang=js"

import "./AudienceHeader.vue?vue&type=style&index=0&id=ce7003ce&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce7003ce"]])

export default __exports__